import React from 'react';
import Router from 'next/router';

class Tools extends React.Component {
  static async getInitialProps(context) {
    const { res } = context;
    const location = '/';
    if (res) {
      res.redirect(301, location);
      res.finished = true;
    } else {
      Router.replace(location);
    }
  }

  render() {
    return null;
  }
}

export default Tools;
